<div class="menu-container">
  <div class="dealer-container">
    <app-menu-card-v3
      *ngFor="let dealer of dealers; trackBy: trackByDealer"
      [dealer]="dealer"
    ></app-menu-card-v3>
  </div>
</div>
